const data = {
  title: "Floor 4-4",
  musicTrack: "MUSIC_WORLD4",
  theme: "GRAY",
  timeLimitSeconds: 120,
  tilesWidth: 9,
  tilesHeight: 12,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 5,
      y: 5
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 5,
      y: 11
    },
    {
      type: "TELEPORT",
      x: 4,
      y: 4
    },
    {
      type: "TELEPORT",
      x: 5,
      y: 4
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 4
    },
    {
      type: "TELEPORT",
      x: 4,
      y: 5
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 5
    },
    {
      type: "TELEPORT",
      x: 4,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 5,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 6
    },
    {
      type: "WATER",
      x: 3,
      y: 7
    },
    {
      type: "WATER",
      x: 3,
      y: 6
    },
    {
      type: "WATER",
      x: 3,
      y: 5
    },
    {
      type: "WATER",
      x: 3,
      y: 4
    },
    {
      type: "WATER",
      x: 3,
      y: 3
    },
    {
      type: "WATER",
      x: 4,
      y: 3
    },
    {
      type: "WATER",
      x: 5,
      y: 3
    },
    {
      type: "WATER",
      x: 6,
      y: 3
    },
    {
      type: "WATER",
      x: 7,
      y: 3
    },
    {
      type: "WATER",
      x: 7,
      y: 4
    },
    {
      type: "WATER",
      x: 7,
      y: 5
    },
    {
      type: "WATER",
      x: 7,
      y: 6
    },
    {
      type: "WATER",
      x: 7,
      y: 7
    },
    {
      type: "WATER",
      x: 6,
      y: 7
    },
    {
      type: "WATER",
      x: 5,
      y: 7
    },
    {
      type: "WATER",
      x: 4,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 4
    },
    {
      type: "ICE",
      x: 3,
      y: 8
    },
    {
      type: "ICE",
      x: 4,
      y: 8
    },
    {
      type: "TELEPORT",
      x: 8,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 2,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 2,
      y: 8
    },
    {
      type: "FIRE",
      x: 1,
      y: 1
    },
    {
      type: "FIRE",
      x: 2,
      y: 1
    },
    {
      type: "FIRE",
      x: 3,
      y: 1
    },
    {
      type: "FIRE",
      x: 4,
      y: 1
    },
    {
      type: "FIRE",
      x: 5,
      y: 1
    },
    {
      type: "FIRE",
      x: 6,
      y: 1
    },
    {
      type: "FIRE",
      x: 7,
      y: 1
    },
    {
      type: "FIRE",
      x: 8,
      y: 1
    },
    {
      type: "FIRE",
      x: 9,
      y: 1
    },
    {
      type: "FIRE",
      x: 9,
      y: 2
    },
    {
      type: "FIRE",
      x: 9,
      y: 3
    },
    {
      type: "FIRE",
      x: 9,
      y: 4
    },
    {
      type: "FIRE",
      x: 9,
      y: 5
    },
    {
      type: "FIRE",
      x: 9,
      y: 6
    },
    {
      type: "FIRE",
      x: 9,
      y: 7
    },
    {
      type: "FIRE",
      x: 9,
      y: 8
    },
    {
      type: "FIRE",
      x: 9,
      y: 9
    },
    {
      type: "FIRE",
      x: 7,
      y: 9
    },
    {
      type: "FIRE",
      x: 6,
      y: 9
    },
    {
      type: "FIRE",
      x: 5,
      y: 9
    },
    {
      type: "FIRE",
      x: 4,
      y: 9
    },
    {
      type: "FIRE",
      x: 3,
      y: 9
    },
    {
      type: "FIRE",
      x: 1,
      y: 9
    },
    {
      type: "FIRE",
      x: 1,
      y: 2
    },
    {
      type: "FIRE",
      x: 1,
      y: 3
    },
    {
      type: "FIRE",
      x: 1,
      y: 4
    },
    {
      type: "FIRE",
      x: 1,
      y: 5
    },
    {
      type: "FIRE",
      x: 1,
      y: 6
    },
    {
      type: "FIRE",
      x: 1,
      y: 7
    },
    {
      type: "FIRE",
      x: 1,
      y: 8
    },
    {
      type: "FIRE",
      x: 4,
      y: 10
    },
    {
      type: "FIRE",
      x: 6,
      y: 10
    },
    {
      type: "FIRE",
      x: 6,
      y: 12
    },
    {
      type: "FIRE",
      x: 4,
      y: 12
    },
    {
      type: "FIRE",
      x: 5,
      y: 12
    },
    {
      type: "FIRE",
      x: 5,
      y: 10
    },
    {
      type: "TELEPORT",
      x: 8,
      y: 11
    },
    {
      type: "TELEPORT",
      x: 2,
      y: 11
    },
    {
      type: "ICE",
      x: 2,
      y: 6
    },
    {
      type: "ICE",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 2
    },
    {
      type: "ENEMY_SPAWN",
      x: 9,
      y: 10,
      direction: "LEFT",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 12,
      direction: "RIGHT",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "ICE",
      x: 7,
      y: 8,
      corner: "TOP_RIGHT"
    },
    {
      type: "ICE",
      x: 8,
      y: 3,
      corner: "TOP_LEFT"
    },
    {
      type: "ICE",
      x: 3,
      y: 2,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 2,
      y: 7,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 6,
      y: 8
    },
    {
      type: "ICE",
      x: 8,
      y: 6
    },
    {
      type: "ICE",
      x: 4,
      y: 2
    },
    {
      type: "ICE",
      x: 2,
      y: 3
    },
    {
      type: "ICE",
      x: 2,
      y: 4
    },
    {
      type: "THIEF",
      x: 8,
      y: 5
    },
    {
      type: "THIEF",
      x: 5,
      y: 8
    },
    {
      type: "THIEF",
      x: 2,
      y: 5
    },
    {
      type: "THIEF",
      x: 5,
      y: 2
    },
    {
      type: "LOCK",
      x: 2,
      y: 9,
      color: "BLUE"
    },
    {
      type: "ICE",
      x: 8,
      y: 8
    },
    {
      type: "KEY",
      x: 2,
      y: 4,
      color: "BLUE"
    },
    {
      type: "KEY",
      x: 8,
      y: 6,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 8,
      y: 9,
      color: "BLUE"
    },
    {
      type: "LOCK",
      x: 4,
      y: 11,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 6,
      y: 11,
      color: "GREEN"
    }
  ]
};

export default data;
